export default __webpack_public_path__ + "static/media/ic_cards.6d1909ee.svg";